// [ai] The manifest in memory (the `library` query): items by id, the folder tree, neighbours, and a fuzzy title/gist filter. Pure.
import { neighbors } from "./transcript";
import type { Folder, Item, Library } from "./types";
export type TreeNode = Folder & { name: string; children: TreeNode[]; items: Item[] };
export function buildTree(lib: Library): TreeNode[] {
  const nodes = new Map<string, TreeNode>(); const roots: TreeNode[] = [];
  for (const f of lib.folders) {
    const node: TreeNode = { ...f, name: f.path.split("/").pop() ?? f.path, children: [], items: [] }; nodes.set(f.path, node);
    const parent = f.path.includes("/") ? nodes.get(f.path.slice(0, f.path.lastIndexOf("/"))) : null;
    (parent ? parent.children : roots).push(node);
  }
  for (const it of lib.items) nodes.get(it.folder)?.items.push(it);
  return roots;
}
export const getItem = (lib: Library | null, id: string): Item | null => lib?.items.find(i => i.id === id) ?? null;
export const itemNeighbors = (lib: Library | null, id: string) => neighbors(lib?.items ?? [], id);
const norm = (s: string | null | undefined) => (s || "").toLowerCase().normalize("NFKD").replace(/[̀-ͯ]/g, "");
export function filterItems(lib: Library | null, q: string, limit = 200): Item[] {
  const terms = norm(q).split(/\s+/).filter(Boolean); if (!terms.length || !lib) return [];
  const out: Item[] = [];
  for (const it of lib.items) {
    const hay = norm(`${it.title} ${it.date} ${it.folder} ${it.gist} ${(it.speakers || []).join(" ")}`);
    if (terms.every(t => hay.includes(t))) { out.push(it); if (out.length >= limit) break; }
  }
  return out;
}
/** Every ancestor path of a folder, the folder included: "a/b/c" → ["a", "a/b", "a/b/c"]. */
export function ancestors(path: string): string[] { const parts = path.split("/"); return parts.map((_, i) => parts.slice(0, i + 1).join("/")); }
